import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { ButtonPrimary } from '../../../common/components';

type HealthCheckUnhealthyModalProps = {
  show: boolean;
  onHide: () => void;
  errorMessage: any;
};

const defaultProps = {
  show: true,
  errorMessage: '',
};

const HealthCheckUnhealthyModalWrapper = styled.div``;

export const HealthCheckUnhealthyModal = (props: HealthCheckUnhealthyModalProps) => {
  const { show } = props;

  const handleCopyToClipboard = (event: any) => {
    event.preventDefault();
    navigator.clipboard.writeText(props.errorMessage);
  };

  const handleClose = (event: any) => {
    event.preventDefault();
    props.onHide();
  };

  return (
    <Modal animation={false} className={'custom-modal'} show={show} backdrop='static' centered>
      <HealthCheckUnhealthyModalWrapper>
        <Modal.Header className='pb-4'>
          <Modal.Title>{props.errorMessage}</Modal.Title>
        </Modal.Header>
        <Modal.Footer className='p-0'>
          <div className='d-flex justify-content-end'>
            <ButtonPrimary className='ml-2' title='Copy to clipboard' onClick={handleCopyToClipboard} />
            <ButtonPrimary className='ml-2' title='Ok' onClick={handleClose} />
          </div>
        </Modal.Footer>
      </HealthCheckUnhealthyModalWrapper>
    </Modal>
  );
};

HealthCheckUnhealthyModal.defaultProps = defaultProps;
